import { Button, KakaoMap } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { PieceBanner } from "@domains/common";
import { useGetLocation, type MapInfoResponse } from "@shared/server";
import { FONT } from "@styles/common";

export const Location = () => {
    const { data } = useGetLocation<MapInfoResponse>({ section: "location" });
    const { isMobile } = useDesignMaxTheme().MEDIAS();

    return data ? (
        <Box w="100%">
            <PieceBanner
                imgUrl={data.imgUrl}
                name={data.pensionInfo.name}
                title={{
                    main: "Location",
                    sub: "오시는 길",
                }}
            />
            <Center as="section" flexDir="column" rowGap={isMobile ? "28px" : "56px"}>
                <Center flexDir="column" rowGap={isMobile ? "32px" : "64px"}>
                    <Center flexDir="column">
                        <Text sx={isMobile ? { ...FONT("cormorant", 32, 500) } : { ...FONT("cormorant", 52, 500) }}>
                            Location
                        </Text>
                        <Text fontFamily="Cormorant">{data.pensionInfo.name.en} PENSION</Text>
                    </Center>
                    <Center flexDir="column" rowGap="8px">
                        <Text sx={isMobile ? { ...FONT("notoSerif", 14, 500) } : { ...FONT("notoSerif", 16, 500) }}>
                            도로명 : {data.pensionInfo.addressDetail.street}
                        </Text>
                        <Text sx={isMobile ? { ...FONT("notoSerif", 14, 500) } : { ...FONT("notoSerif", 16, 500) }}>
                            지번 : {data.pensionInfo.addressDetail.jibun}
                        </Text>
                    </Center>
                </Center>
                <KakaoMap latLng={data.latLng} name={data.pensionInfo.name.kr} />
                <Center columnGap="16px">
                    <Button sizeType="medium">네이버 길찾기</Button>
                    <Button sizeType="medium">카카오 길찾기</Button>
                </Center>
            </Center>
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
